import axios from "axios";
import { Constants } from "../utils/Constants";

export function list(archived = false) {
    return axios.get(`${Constants.baseUrl}/notifications`, { params: { archived: archived ? 1 : 0 } });
}

export function read(id) {
    return axios.patch(`${Constants.baseUrl}/notifications/${id}/read`);
}

export function archive(id, archived = true) {
    return axios.patch(`${Constants.baseUrl}/notifications/${id}/archive`, { archived });
}

export function remove(id) {
    return axios.delete(`${Constants.baseUrl}/notifications/${id}`);
}
